import { IPermission } from "common/constant/IPermission";
import { Strings } from "common/utility/string/string";

export abstract class Claims {
    private _type: string = Strings.Empty

    constructor(type: string) {
        this._type = type
    }

    public get type(): string {
        return this._type
    }

    public createPermissions(identifiers: Array<string>): Array<IPermission> {
        const returnValue: Array<IPermission> = []
        identifiers = Array.isArray(identifiers) ? identifiers : [identifiers]

        identifiers.forEach(identifier => {
            returnValue.push({
                identifier: identifier,
                claimType: this.type
            })
        })
        return returnValue
    }

}